export default __webpack_public_path__ + "static/media/house2318976.1ce55977.jpg";